/*-------------------------
 SLOT CLASS ADDITION

 adds classes to each slot
 depending on its name or
 type props
--------------------------*/
export const slotClassAddition = {
  methods: {
    addSlotClasses() {
      const slotNames = Object.keys(this.$slots);
      slotNames.forEach((slotName) => {
        const slots = this.$slots[slotName];
        slots.forEach((slot) => {
          if (!slot.data || !slot.elm) return;
          const { type, subtype } = slot.data.attrs;
          const slotElem = slot.elm;
          if (this[`${type}Class`]) {
            slotElem.className = this[`${type}Class`];
          } else {
            const slotProp = this[`${slotName}Class`];
            let className;
            if (type) {
              className = `${slotProp} ${slotProp}--${type}`;
              if (subtype) {
                className = `${slotProp} ${slotProp}--${type} ${slotProp}--${subtype}`;
              }
            } else {
              className = slotProp;
            }
            if (className) {
              slotElem.className = className;
            }
          }
        });
      });
    },
  },
};

export default slotClassAddition;
